import { c as _c } from "react/compiler-runtime";
import { Trans } from 'react-i18next';
import { MainLayout } from '../../MainLayout';
import { PageHeading } from '../../layout/PageHeading';
import { PianoIdentity } from '../../layout/PianoIdentity';
import { PrintButton } from '../../layout/PrintButton';
import { DesignStepsBar } from '@/components/design/steps/DesignStepsBar';
import { useAnalyzedKeyboard } from '../../../hooks/keyboard/use-analyzed-keyboard';
import { usePrintLandscape } from '@/hooks/use-print-page-size';
import { useTranslation } from '@/hooks/use-translation';
import { FrontWeightDesign } from '@/components/design/front-weight/FrontWeightDesign';
export const DesignFrontWeightPage = () => {
  const $ = _c(20);
  const analyzedKeyboard = useAnalyzedKeyboard();
  const {
    t
  } = useTranslation();
  usePrintLandscape();
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <><PianoIdentity /><PrintButton /></>;
    t1 = <DesignStepsBar currentStepId="front-weight" />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <em className="ptl-accent">Weight</em>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  let t4;
  if ($[3] !== t) {
    t3 = <Trans t={t} i18nKey="Front <1>Weight</1>">Front {t2}</Trans>;
    t4 = t("Compute the ideal weight of your keys from the balance weight you are aiming for, or follow a standard curve.");
    $[3] = t;
    $[4] = t3;
    $[5] = t4;
  } else {
    t3 = $[4];
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3 || $[7] !== t4) {
    t5 = <PageHeading title={t3} lede={t4} />;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t) {
    t6 = t("Not enough data");
    $[9] = t;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t) {
    t7 = t("Not enough data to generate a front weight design.");
    $[11] = t;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== analyzedKeyboard || $[14] !== t6 || $[15] !== t7) {
    t8 = <FrontWeightDesign analyzedKeyboard={analyzedKeyboard} requiredDataPercentage={0.8} notEnoughDataErrorTitle={t6} notEnoughDataErrorDescription={t7} />;
    $[13] = analyzedKeyboard;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t5 || $[18] !== t8) {
    t9 = <MainLayout headerRight={t0}>{t1}{t5}{t8}</MainLayout>;
    $[17] = t5;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  return t9;
};